import wx from 'weixin-js-sdk';
import { stringify } from 'qs';
import { isWeChatBrowser } from '@/utils/is';
import { getOfficialAccountsConfig } from '@/api/public';
import { getUrlParams } from '@/utils/index';
import { hasSinogram } from '@/utils/validate';

export const filterHtml = (str) => {
  const reg = new RegExp('<[^>]+>', 'gi'); // 过滤所有的html标签，不包括内容

  if (typeof str !== 'string' || !str) {
    return str;
  }
  const desc = str?.replace(reg, '');
  return desc?.slice(0, 20); // 保留前20位字符
};

/**
 * 微信分享
 * 获取微信加签信息
 * @param{data}:获取的微信加签
 * @param{shareData}:分享配置参数
 */
export const wexinShare = async(shareData) => {
  // 判断用户是否在微信打开
  console.log('判断用户是否在微信打开', isWeChatBrowser());
  if (!isWeChatBrowser()) {
    return;
  }
  const params = {
    url: window.location.href,
  };
  console.log('params==>', params);
  const { data } = await getOfficialAccountsConfig(params);
  console.log('data=======>', data);
  const { appId, timestamp, nonceStr, signature } = data;
  const { title, desc, imgUrl } = shareData;
  const shareUrl = window.location.href; // 分享链接
  console.log('shareData==>', shareData);
  console.log('shareUrl==>', shareUrl);
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。（测试记得关掉）
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature, // 必填，签名，见附录1
    jsApiList: [
      'updateAppMessageShareData', // 分享给朋友
      'updateTimelineShareData', // 分享到朋友圈
    ],
  });
  wx.checkJsApi({
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: function(res) {
      // 以键值对的形式返回，可用的api值true，不可用为false
      console.log(res, 'checkJsApi');
    },
  });
  wx.ready(function() {
    // 分享到朋友圈”及“分享到QQ空间”
    wx.updateTimelineShareData({
      title, // 分享标题
      desc: filterHtml(desc), // 分享描述
      link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function(res) {
        // 设置成功
        console.log('分享朋友圈成功返回的信息为:', res);
      },
    });

    // “分享给朋友”及“分享到QQ”
    wx.updateAppMessageShareData({
      title,
      desc: filterHtml(desc),
      link: shareUrl,
      imgUrl,
      success: function(res) {
        console.log('分享朋友成功返回的信息为:', res);
      },
    });
  });
  wx.error(function(res) {
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    console.log('验证失败返回的信息:', res);
  });
};

const oauthSuccessCode = 'WORK_WX_OAUTH_SUCCESS';
/**
 * 获取企业微信的OAuth授权
 * https://developer.work.weixin.qq.com/document/path/91022
 *
 * @param {HTMLElement} el 容纳iframe的容器
 * @return {Promise<string>}
 */
export const workWxOAuth = (el) => {
  return new Promise((resolve, reject) => {
    const url = 'https://open.weixin.qq.com/connect/oauth2/authorize';
    const params = {
      appid: 'ww1f476c4f2b833d85', // 企业的CorpID
      redirect_uri: encodeURIComponent(window.location.origin), // 授权后重定向的回调链接地址
      response_type: 'code', // 返回类型，此时固定为：code
      scope: 'snsapi_privateinfo', // 应用授权作用域。
      agentid: '1000043',
      state: oauthSuccessCode,
    };
    const iframe = document.createElement('iframe');
    const prevElPosition = el.style.position;
    el.style.position = 'relative';
    iframe.classList.add('nx-workwx-oauth-iframe'); // in @/styles/global.scss
    iframe.src = `${url}?${stringify(params)}#wechat_redirect`;
    el.appendChild(iframe);

    window.onOAuthResult = (code) => {
      el.style.position = prevElPosition;
      iframe.remove();
      resolve(code);
    };
  });
};

/**
 * 全局注册监听企业微信OAuth授权的重定向
 */
export const registerWxWorkOAuthRedirect = () => {
  const windowParams = getUrlParams(window.location.search);
  if (windowParams.state === oauthSuccessCode) {
    parent?.window?.onOAuthResult(windowParams.code);
  }
};

/**
 * 微信保存海报图片
 * 图片不能是Base64，Base64需要转为临时url
 * @posterImg 海报图
 * @codeImg 二维码图
 */
export const wxSaveShareBanner = (posterImg, codeImg) => {
  wx.miniProgram.navigateTo({
    url: `/packageA/pages/shareBanner/index?posterImg=${posterImg}&codeImg=${codeImg}`,
  });
};

/**
 * 企业微信分享到朋友圈设置
 * 企业微信抓取规则：
 * 1、标题取页面的title标签内容
 * 2、图片取页面的第一个img标签内容，且图片宽高需要大于200才支持抓取
 */
export const wxWorkShareConfig = ({ title = '北京汽车', imgUrl = '' }) => {
  if (!imgUrl || hasSinogram(decodeURI(imgUrl))) {
    // 图片链接中包含中文，企微抓取图片会失败，默认改为北京汽车logo图
    imgUrl = 'https://cdn-zone.app-prod.bjev.com.cn/logo-new.png?x-oss-process=image/resize,w_500/quality,q_90';
  }
  document.title = title.slice(0, 15); // 取前15个字符
  var img = document.createElement('img');
  img.src = imgUrl;
  img.style.display = 'none';
  img.style.width = '300px';
  img.style.height = '300px';
  var first = document.body.firstChild;
  document.body.insertBefore(img, first);
};
